import { requestConfirmation } from "../lib/confirmation";
import { Controller } from '@hotwired/stimulus'
import { i18n } from '../lib/i18n'

// Handles bulk auto-fixing of failed fields in data source validation
export default class extends Controller {
  static values = {
    fields: Array,
    dataSourceId: Number
  }

  async fixAll() {
    const fields = this.fieldsValue
    if (!fields.length) return

    // Confirm before applying all fixes
    const message = i18n.t('auto_fix_all.confirm_fixes', { count: fields.length })
    if (!await requestConfirmation(message)) return

    // Disable button and show loading state
    this.element.disabled = true
    const originalHTML = this.element.innerHTML
    this.element.innerHTML = `<span class="loading loading-spinner loading-sm"></span> ${i18n.t('auto_fix_all.fixing_fields', { count: fields.length })}`

    try {
      // Use the bulk endpoint for efficiency
      const response = await fetch(`/admin/report_data_sources/${this.dataSourceIdValue}/report_data_fields/bulk_quick_fix`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: JSON.stringify({
          fixes: fields.map(f => ({ id: f.id, expression: f.expression }))
        })
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        console.error('Bulk fix failed:', await response.text())
        alert(i18n.t('auto_fix_all.some_fixes_failed'))
        // Restore button
        this.element.disabled = false
        this.element.innerHTML = originalHTML
      }
    } catch (error) {
      console.error('Error during bulk fix:', error)
      alert(i18n.t('auto_fix_all.error_occurred'))
      // Restore button
      this.element.disabled = false
      this.element.innerHTML = originalHTML
    }
  }
}
